import { MoneyConnectClientAPI } from "./axios-service-creator";

export const PortfolioAPI = {
  getCustomerCareContact: (signal) =>
    MoneyConnectClientAPI.get("/consolidate/portfolio/employeeContactInfo", { signal }),
  getBankDeposit: (signal) => MoneyConnectClientAPI.get("/consolidate/portfolio/bankDeposit", { signal }),
  getFundByUnitholder: (payload, signal) =>
    MoneyConnectClientAPI.post("/consolidate/portfolio/mutualFund", payload, { signal }),
  getBond: (signal) => MoneyConnectClientAPI.get("/consolidate/portfolio/bond", { signal }),
  getStructureNote: (signal) => MoneyConnectClientAPI.get("/consolidate/portfolio/structureNote", { signal }),
  getUnitholders: (signal) => MoneyConnectClientAPI.get("/consolidate/portfolio/unitholderMutualFund", { signal }),
  getMutualFundListByType: (payload, signal) =>
    MoneyConnectClientAPI.post("/consolidate/portfolio/mutualFundListByType", payload, { signal }),
  getFundTransactions: (payload, signal) =>
    MoneyConnectClientAPI.post("/consolidate/portfolio/mutualFundTransactionDetail", payload, { signal }),
};
